<template>
<div class="ResourcePage">
  <header-component></header-component>
    <resource-promo></resource-promo>
    <resource-services></resource-services>
    <resource-suggest></resource-suggest>
  <footer-component></footer-component>
</div>
</template>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
import ResourcePromo from "@/components/portal/resourceData/ResourcePromo";
import ResourceServices from "@/components/portal/resourceData/ResourceServices";
import ResourceSuggest from "@/components/portal/resourceData/ResourceSuggest";
export default {
  components: {HeaderComponent, 
               FooterComponent, 
               ResourcePromo,
               ResourceServices,
               ResourceSuggest},
  data(){
        return{
        }
  },
  methods: {
  },
  created(){
    localStorage.setItem('is-active','resource');
  }
}
</script>


// WEBPACK FOOTER //
// Resource.vue?1bef51a9